export const SESSION_CHANGED = 'auth-session-changed';
export const SESSION_EXPIRED = 'auth-session-expired';

export function tokenExpiresAt(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const { exp } = JSON.parse(atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, '=')));
    return typeof exp === 'number' && Number.isFinite(exp) ? exp * 1000 : null;
  } catch { return null; }
}

export function clearSession() {
  ['user', 'token', 'user.role'].forEach(key => sessionStorage.removeItem(key));
}

export function expireSession() {
  clearSession();
  window.dispatchEvent(new Event(SESSION_EXPIRED));
}
